// extracted by mini-css-extract-plugin
module.exports = {"resendLink":"Dashboard_resendLink__Dm2q6","Home":"Dashboard_Home__SZADy","cardHeader":"Dashboard_cardHeader__sGwnS","cardTitle":"Dashboard_cardTitle__1vtkl"};